<template>
  <div>
    <div class="chart-title-sm mt-4">Displayed by traders</div>
    <div class="width-full float-left text-center mt-4">
      <v-chip
        v-for="visitor in visitedBy"
        :key="visitor._id"
        pill
        class="ma-1 pointer"
        color="#404855"
        @click="routeUser(visitor.visitor.username)"
      >
        <v-avatar left>
          <Avatar
            v-if="visitor.visitor.avatar != null"
            class
            :src="`https://tradeinpool.com/upload/${visitor.visitor.avatar}.png`"
            :size="33"
          ></Avatar>
          <Avatar v-else class :username="visitor.visitor.username" :size="33"></Avatar>
        </v-avatar>
        {{visitor.visitor.username}}
      </v-chip>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
export default {
  components: {Avatar},
  props: { visitors: Array },
  data() {
    return {
      visitedBy: []
    };
  },
  methods:{
      routeUser(name) {
      this.$router.push({
        name: "user",
        params: { name: name }
      });
    },
      visitorsRegroup() {
      var data = this.visitors
      this.visitedBy = data.reduce((acc, obj) => {
        var exist = acc.find(
          ({ visitor }) => obj.visitor.username === visitor.username
        );
        if (!exist) {
          acc.push(obj);
        }
        return acc;
      }, []);
    },
  },
  watch:{
      visitors(){
          this.visitorsRegroup();
      }
  },
  mounted(){
      this.visitorsRegroup();
  }
};
</script>

<style>
</style>